var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-end sticky to-header"
  }, [_vm.exportDialog ? _c('Export-dialog', {
    attrs: {
      "api-endpoint": `/access-levels/exportOne?id=${_vm.$route.params.id}`,
      "filename": `${_vm.page.breadcrumbItem.text} hozzáférési szint kártyái`,
      "worksheet-options": _vm.exportWorksheetOptions,
      "worksheet-options-item-text": "name",
      "worksheet-options-item-value": "element_id"
    },
    on: {
      "close": function ($event) {
        _vm.exportDialog = false;
      }
    }
  }) : _vm._e()], 1), _c('title-row', {
    attrs: {
      "title": _vm.page.title,
      "subtitle": _vm.page.subtitle,
      "breadcrumb-items": [{
        text: 'Hozzáférési szintek',
        to: {
          name: 'AccessLevelList'
        }
      }, _vm.page.breadcrumbItem]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('title-row-button', {
          attrs: {
            "title": "Exportálás"
          },
          on: {
            "click": function ($event) {
              _vm.exportDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-file-export")]), _vm._v(" Exportálás ")], 1), _c('title-row-button', {
          attrs: {
            "disabled": _vm.loading
          },
          on: {
            "click": _vm.save
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Mentés ")], 1)];
      },
      proxy: true
    }])
  }), _c('v-card', {
    staticClass: "rounded-xl overflow-hidden",
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "align-tabs": "center",
      "color": "text--primary"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _c('v-tab', {
    key: "meta"
  }, [_vm._v(" Alapadatok ")]), _c('v-tab', {
    key: "assets"
  }, [_vm._v(" Eszközök ")]), _c('v-tab', {
    key: "cards"
  }, [_vm._v(" Kártyák ")])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "meta",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "loading": _vm.loading
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-security")]), _vm._v(" Alapadatok ")], 1), _c('v-card-text', [_c('v-row', {
    staticClass: "m-1"
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.$config.inputMasks.name,
      expression: "$config.inputMasks.name"
    }],
    attrs: {
      "error-messages": _vm.errors.name,
      "label": "Megnevezés",
      "filled": ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('v-text-field', {
    directives: [{
      name: "uppercase",
      rawName: "v-uppercase"
    }],
    attrs: {
      "label": "Alias",
      "disabled": !_vm.form.erasable,
      "error-messages": _vm.errors.alias,
      "filled": ""
    },
    model: {
      value: _vm.form.alias,
      callback: function ($$v) {
        _vm.$set(_vm.form, "alias", $$v);
      },
      expression: "form.alias"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "label": "Csoportok",
      "items": _vm.groups,
      "item-text": "name",
      "item-value": "element_id",
      "error-messages": _vm.errors.groups,
      "multiple": "",
      "chips": "",
      "hide-details": "",
      "filled": ""
    },
    model: {
      value: _vm.form.group_ids,
      callback: function ($$v) {
        _vm.$set(_vm.form, "group_ids", $$v);
      },
      expression: "form.group_ids"
    }
  }), _c('v-switch', {
    attrs: {
      "label": "QR kód engedélyezve",
      "error-messages": _vm.errors.barcode_enabled
    },
    model: {
      value: _vm.form.barcode_enabled,
      callback: function ($$v) {
        _vm.$set(_vm.form, "barcode_enabled", $$v);
      },
      expression: "form.barcode_enabled"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "sm": 12,
      "md": 6
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "uppercase",
      rawName: "v-uppercase"
    }],
    attrs: {
      "label": "QR kód info",
      "error-messages": _vm.errors.barcode_info,
      "filled": ""
    },
    model: {
      value: _vm.form.barcode_info,
      callback: function ($$v) {
        _vm.$set(_vm.form, "barcode_info", $$v);
      },
      expression: "form.barcode_info"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": "Megjegyzés",
      "error-messages": _vm.errors.comment,
      "filled": "",
      "rows": 3,
      "auto-grow": ""
    },
    model: {
      value: _vm.form.comment,
      callback: function ($$v) {
        _vm.$set(_vm.form, "comment", $$v);
      },
      expression: "form.comment"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-tab-item', {
    key: "assets",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "loading": _vm.loading
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-chip")]), _vm._v(" Eszközök ")], 1), _c('v-card-text', [_c('MultiSelectLists', {
    attrs: {
      "headers": [{
        text: 'Eszköz',
        value: 'device'
      }, {
        text: 'Engedélyezve',
        value: 'schedule_allow'
      }, {
        text: 'Letiltva',
        value: 'schedule_deny'
      }],
      "items": _vm.elements,
      "item-text": "name",
      "item-value": "element_id",
      "blank-item-template": {
        element_id: 0,
        schedule_group_id_allow: 0,
        schedule_group_id_deny: 0
      },
      "unique-values": ""
    },
    scopedSlots: _vm._u([{
      key: `item.device`,
      fn: function (_ref) {
        var item = _ref.item,
          items = _ref.items;
        return [_c('v-autocomplete', {
          attrs: {
            "placeholder": "Eszköz",
            "items": items,
            "item-text": "name",
            "item-value": "element_id",
            "filled": "",
            "hide-details": "",
            "required": "",
            "value-comparator": _vm.$config.comparators.isEqual,
            "loading": _vm.elements.length == 0
          },
          model: {
            value: item.element_id,
            callback: function ($$v) {
              _vm.$set(item, "element_id", $$v);
            },
            expression: "item.element_id"
          }
        })];
      }
    }, {
      key: `item.schedule_allow`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-autocomplete', {
          attrs: {
            "placeholder": "Soha",
            "items": _vm.scheduleGroups,
            "item-value": "id",
            "item-text": "name",
            "filled": "",
            "hide-details": "",
            "clearable": ""
          },
          model: {
            value: item.schedule_group_id_allow,
            callback: function ($$v) {
              _vm.$set(item, "schedule_group_id_allow", $$v);
            },
            expression: "item.schedule_group_id_allow"
          }
        })];
      }
    }, {
      key: `item.schedule_deny`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-autocomplete', {
          attrs: {
            "placeholder": "Soha",
            "items": _vm.scheduleGroups,
            "item-value": "id",
            "item-text": "name",
            "filled": "",
            "hide-details": "",
            "clearable": ""
          },
          model: {
            value: item.schedule_group_id_deny,
            callback: function ($$v) {
              _vm.$set(item, "schedule_group_id_deny", $$v);
            },
            expression: "item.schedule_group_id_deny"
          }
        })];
      }
    }], null, true),
    model: {
      value: _vm.form.elements,
      callback: function ($$v) {
        _vm.$set(_vm.form, "elements", $$v);
      },
      expression: "form.elements"
    }
  })], 1)], 1)], 1), _c('v-tab-item', {
    key: "cards",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "loading": _vm.loading
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-card-account-details-outline")]), _vm._v(" Kártyák hozzárendelése")], 1), _c('v-card-text', [_c('v-two-panel-multiselect', {
    attrs: {
      "headers": [{
        text: 'Kártyaszám',
        value: 'card_number'
      }, {
        text: 'Birtokos',
        value: 'owner_name'
      }, {
        text: 'RFID',
        value: 'rf_id'
      }],
      "search-fields": ['card_number', 'owner_name', 'rf_id'],
      "options": {
        sortBy: ['card_number']
      },
      "items": _vm.cards,
      "item-value": "element_id"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (_ref4) {
        var search = _ref4.search;
        return [_c('v-card', {
          staticClass: "mb-6",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-card-title', [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-filter")]), _vm._v(" Keresés ")], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": 12,
            "md": 6,
            "lg": 3
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Kártyatulajdonos",
            "hide-details": "",
            "filled": ""
          },
          model: {
            value: search.owner_name,
            callback: function ($$v) {
              _vm.$set(search, "owner_name", $$v);
            },
            expression: "search.owner_name"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": 12,
            "md": 6,
            "lg": 3
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Kártyaszám",
            "hide-details": "",
            "filled": ""
          },
          model: {
            value: search.card_number,
            callback: function ($$v) {
              _vm.$set(search, "card_number", $$v);
            },
            expression: "search.card_number"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": 12,
            "md": 6,
            "lg": 3
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "RFID",
            "hide-details": "",
            "filled": ""
          },
          model: {
            value: search.rf_id,
            callback: function ($$v) {
              _vm.$set(search, "rf_id", $$v);
            },
            expression: "search.rf_id"
          }
        })], 1)], 1)], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.form.cards,
      callback: function ($$v) {
        _vm.$set(_vm.form, "cards", $$v);
      },
      expression: "form.cards"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }